import { isSoftClinicalSubmitWorkflow } from '@ldt/features/orders/utils/order_missing_info';
import { canUseTStageNotProvided } from 'src/distribution_platforms/features/order_form';
import { WorkflowType } from 'src/types/workflows';

/**
 * T Stage / NCCN Not Provided is only for Clinic + Direct Upload soft-clinical
 * workflows (plus the org clinician flag within those workflows).
 */
export function canUseClinicalNotProvided(
  isCSOrSalesUser: boolean,
  allowTStageNotProvidedOrgFlag: boolean,
  workflowType: WorkflowType,
): boolean {
  return (
    isSoftClinicalSubmitWorkflow(workflowType) &&
    canUseTStageNotProvided(isCSOrSalesUser, allowTStageNotProvidedOrgFlag)
  );
}
